import React from 'react';
import { Text } from '@react-pdf/renderer';

type RenderMode = 'html' | 'pdf';

export const formatMessageWithBoldTitle = (message: string, renderAs: RenderMode = 'html'): React.ReactNode => {
  const regex = /##(.*?)##/;
  const match = message.match(regex);

  if (!match) {
    return renderAs === 'pdf' ? <Text>{message}</Text> : <div>{message}</div>;
  }
  const [fullMatch, boldText] = match;
  const parts = message.split(fullMatch);

  if (renderAs === 'pdf') {
    return (
      <Text>
        {parts[0]}
        <Text style={{ fontWeight: 'bold' }}>{boldText}</Text>
        {parts[1]}
      </Text>
    );
  } else {
    return (
      <>
        {parts[0]}
        <strong>{boldText}</strong>
        {parts[1]}
      </>
    );
  }
};

export const maskEmail = (email: string): string => {
  try {
    const [local, domainPart] = email.split('@');
    if (!domainPart) {
      return email;
    }

    const domainMatch = domainPart.match(/^(.)([^.]*)(\..+)$/);
    if (!domainMatch) {
      return email;
    }

    const [, firstChar, restBeforeDot, domainSuffix] = domainMatch;

    const maskedLocal = local.length <= 4 ? local : local.slice(0, 4) + '*'.repeat(local.length - 4);

    const maskedDomain = firstChar + '*'.repeat(restBeforeDot.length);

    return `${maskedLocal}@${maskedDomain}${domainSuffix}`;
  } catch {
    return email;
  }
};
